export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const MAX_PHOTO_INPUT_BYTES = 10 * 1024 * 1024;
export const MAX_PHOTO_UPLOAD_BYTES = 1024 * 1024;
export const AVATAR_SIDE = 512;

export function photoSrc(
  apiUrl: string,
  userId: string,
  photoVersion: string | null | undefined,
): string | null {
  if (!photoVersion) return null;
  return `${apiUrl}/users/${encodeURIComponent(userId)}/photo?v=${encodeURIComponent(photoVersion)}`;
}

export function photoFileProblem(type: string, size: number): string | null {
  if (!PHOTO_TYPES.includes(type)) return 'Choose a JPEG, PNG or WebP image.';
  if (size > MAX_PHOTO_INPUT_BYTES) return 'The image must be smaller than 10 MB.';
  return null;
}

export function squareCrop(
  width: number,
  height: number,
): { sx: number; sy: number; side: number } {
  const side = Math.min(width, height);
  return {
    sx: Math.floor((width - side) / 2),
    sy: Math.floor((height - side) / 2),
    side,
  };
}
